import { COLUMN_CODE, COLUMN_CREDENTIALS, COLUMN_DESCRIPTION, COLUMN_EXPIRY_DATE, COLUMN_STATUS, COLUMN_TYPE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const TagColumns : TableColumn[] = [
    {
        heading: "Credentials",
        accessor: "credentials",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "credentials",
        columnId: COLUMN_CREDENTIALS,
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 2,
        // sortByName: "tagTypeName",
        // sortDirection: "asc",
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Code",
        accessor: "code",
        isNumeric: false,
        id: 3,
        sortByName: "credCode",
        sortDirection: "asc",
        active: true,
        translationKey: "code",
        columnId: COLUMN_CODE,
    },
    {
        heading: "Description",
        accessor: "description",
        isNumeric: false,
        id: 4,
        sortByName: "credDesc",
        sortDirection: "asc",
        active: true,
        translationKey: "description",
        columnId: COLUMN_DESCRIPTION,
    },
    {
        heading: "Status",
        accessor: "status",
        isNumeric: false,
        id: 5,
        // sortByName: "tagStatus",
        // sortDirection: "asc",
        active: true,
        translationKey: "status",
        columnId: COLUMN_STATUS,
    },
    {
        heading: "Expiry Date",
        accessor: "expiryDate",
        isNumeric: false,
        id: 6,
        // sortByName: "tagExpiryDate",
        // sortDirection: "asc",
        active: true,
        translationKey: "expiryDate",
        columnId: COLUMN_EXPIRY_DATE,
    },
    {
        heading: "Byte Reversed",
        accessor: "tagByteReversedLabel",
        isNumeric: false,
        id: 7,
        // sortByName: "tagByteReversed",
        // sortDirection: "asc",
        active: true,
        translationKey: "byteReversed",
    },
    {
        heading: "OSS Enabled",
        accessor: "tagOssLabel",
        isNumeric: false,
        id: 8,
        active: true,
        translationKey: "ossEnabled",
    },
    {
        heading: "Tag Blocklist Date",
        accessor: "tagBlocklistDate",
        isNumeric: false,
        id: 9,
        active: true,
        translationKey: "tagBlocklistDate"
    }
];

export default TagColumns;
